import React from 'react';
import { useSelector } from 'react-redux';

import type { RootState } from '../../../store/models';
import store from '../../../store';
import { ProfileEntry } from '../../pages/ProProfile/ProProfile.model';

import { makeProfileMessageGenerator, generatePlatformMessage } from '../../../modules/referral/helpers';

import { selectors } from '../../../store/CurrentUser.model';

import { useIsMobile } from '../../../hooks';
import { useReferralEntrypointProps } from '../referrals/useReferralEntrypointProps';
import { ShareTarget } from '../../../modules/share';

export const useHeaderReferralEntry = (isOnProfilePage: boolean) => {
  const isMobile = useIsMobile();
  const isLoggedIn = useSelector(selectors.isLoggedIn);

  const stateName = useSelector<RootState, string>(state => state.route.name);
  const profileIdOrVanity = useSelector<RootState, string>(state => state.route.params?.providerId);
  const {
    profile,
  } = useSelector<RootState, ProfileEntry>(
    store.select.proProfile.byIdOrVanity({ providerId: profileIdOrVanity }),
  ) || {};

  const [referralShareHookParams, setReferralShareHookParams] = React.useState<any>({
    message: generatePlatformMessage,
    target: ShareTarget.PLATFORM,
    location: 'client_header',
  });

  React.useEffect(() => {
    // don't assign if logged out, on mobile, and on the home page
    // because we hide the referral entry point in this case
    if (
      (stateName.startsWith('home') || stateName.startsWith('start'))
      && !isLoggedIn
      && isMobile
    ) return;

    if (isOnProfilePage && profile) {
      setReferralShareHookParams({
        message: makeProfileMessageGenerator(profile),
        target: ShareTarget.PROFILE,
        provider: profile as any,
        location: 'client_header',
      });
    }
  }, [
    isOnProfilePage,
    profile,
    isLoggedIn,
    stateName,
    isMobile,
  ]);

  const referralShareProps = useReferralEntrypointProps(referralShareHookParams);

  return referralShareProps;
};
